(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('audit', {
                parent: 'entity',
                url: '/audit',
                data: {
                    authorities: [],
                    pageTitle: 'Audit'
                },
                ncyBreadcrumb: {
                    label: 'Audit'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/audit/list/audit.html',
                        controller: 'AuditController',
                        controllerAs: 'vm'
                    }
                },
            })
    }
})();
